import { mapContentToCardData } from '../../../../../domain/utils/contentUtils';

export const getContentPackageStackCardDatum = data => {
  const stackCardDatum = data.stack
    .map(stackItem => {
      if (stackItem.entity?.itemReference?.entity) {
        const cardDataFields = [
          'taxonomies',
          'videoDuration',
          'isAnimated',
          'sponsored'
        ];
        if (!stackItem.entity.hideDescription) {
          cardDataFields.push('subtitle');
        }

        const cardData = mapContentToCardData(
          stackItem.entity.itemReference.entity,
          cardDataFields
        );

        if (stackItem.entity.showCTA) {
          cardData.showCTA = true;
        }

        return cardData;
      }
      return null;
    })
    // Filter out null values
    .filter(item => item);

  return stackCardDatum;
};
